<script>
  import { browser } from '$app/environment';
  import DebugButton from './DebugButton.svelte';
</script>

<!-- Theme toggle   -->
{#if browser}
  <div class="p-4">
    <DebugButton
      text="Toggle Theme"
      on:click={() => {
        document.documentElement.classList.toggle('dark');
        if (document.documentElement.classList.contains('dark')) {
          localStorage.theme = 'dark';
        } else {
          localStorage.theme = 'light';
        }
      }}
    />
    <DebugButton
      text="System pref"
      on:click={() => {
        // Whenever the user explicitly chooses to respect the OS preference
        localStorage.removeItem('theme');
        document.documentElement.classList.remove('dark');
        if (
          localStorage.theme === 'dark' ||
          (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
        ) {
          document.documentElement.classList.add('dark');
        } else {
          document.documentElement.classList.remove('dark');
        }
      }}
    />
  </div>
{/if}
